import Sign from "../../models/Sign";
import "./SignModal.css"
import { Loading } from "../Misc/Loading";
import { Video } from "../Misc/Video";
import SignVocabPills from "./SignVocabPills";
import { useEffect, useState } from "react";
import { learnSign } from "../../services/api";
import { useSignIsLearnt } from "../../hooks/useALSE";
import { get_provider_icon, get_copyright_icon } from "../../utils/provider_elements";
import SignProvider from "../../models/SignProvider";
import { fetchSignProvidersCached } from "../../cachedStaticData";
import Modal from "../Modal/Modal";

interface SignModalProps {
    isOpen: boolean; 
    onClose: () => void; 
    sign: Sign | null;
    onSingLearnChanged?: (learnt: boolean) => void;
}

export default function SignModal({isOpen, onClose, sign, onSingLearnChanged}: SignModalProps) {
    const [providers, setProviders] = useState<Record<number, SignProvider>>({});
    const { data: isLearnt, loading, error, setData: setIsLearnt } = useSignIsLearnt(sign?.sign_id ?? -1, [isOpen, onClose]);
    const [provider, setProvider] = useState<SignProvider | undefined>(undefined);

    const handleLearnSign = async (sign_id: number, learn: boolean) => {
        const response = await learnSign(sign_id, learn);
        setIsLearnt(response.learnt);
        if (response.learnt !== null && onSingLearnChanged) {
            onSingLearnChanged(response.learnt);
        }
    }

    // Reload providers
    useEffect(() => {
        if (!isOpen) return;
        
        const fetchData = async() => {
            setProviders((await fetchSignProvidersCached()).reduce<Record<number, SignProvider>>((acc, item) => {
                acc[item.sign_provider_id] = item;
                return acc;
            }, {}));
        }
        fetchData();
    }, [isOpen]);

    // Set provider
    useEffect(() => {
      if(!providers || !sign) return;
      setProvider(providers[sign.sign_provider_id])
    }, [providers, sign]);

    return (
      <Modal title={sign?.name ?? "Loading... 🔄️"} isOpen={isOpen} onClose={onClose} content={
        <>
          <SignVocabPills isOpen={isOpen} sign={sign} />
          <div className="video-container">
            <Video src={sign?.video_url ?? ''} />
            <div className="sub-video">
              { get_provider_icon(provider) }
              { get_copyright_icon(provider) }
            </div>
          </div>
          {sign?.definition ? <p className="capitalize text-center">{sign?.definition}</p> : <Loading />}
          {
            !loading && !error &&isLearnt !== null && sign ? 
              <div className="fav-button-container">
                <button className={"btn mx-auto " + (isLearnt ? 'error' : 'ok')} onClick={() => handleLearnSign(sign.sign_id, !isLearnt)}>
                  {isLearnt ? 'Quitar de favoritos ⭐' : 'Añadir a favoritos ⭐'}
                </button> 
              </div>:
            null
          }
        </>
      }/>
    );
};

